import { useDomainContext } from "@hooks/useDomainContext";
import React from "react";
import styles from "./styles.module.scss";
import { useRouter } from "next/router";
import { gettingQueriesAsString } from "@lib/shared/routerQueriesToString";

const CrossSellingDomains = () => {
    const { category, domain: currentDomain } = useDomainContext();
    const { query } = useRouter();

    const crossSellingDomains = category?.config?.crossSellingDomains;

    if (!crossSellingDomains) return null;

    return (
        <div className={` ${styles.container}`}>
            <div className="max-w-7xl mx-auto py-10 md:py-20 px-4 mt-24">
                {category?.config?.crossSellingDomainsTitle && (
                    <div
                        className="text-3xl font-bold mb-3"
                        dangerouslySetInnerHTML={{
                            __html: category?.config?.crossSellingDomainsTitle,
                        }}
                    />
                )}
                {category?.config?.crossSellingDomainsDescription && (
                    <div
                        className="mb-1"
                        dangerouslySetInnerHTML={{
                            __html: category?.config
                                ?.crossSellingDomainsDescription,
                        }}
                    />
                )}
                <div className="flex gap-8 mt-10 flex-col md:flex-row">
                    {crossSellingDomains.map((domain) => (
                        <div
                            key={domain.title}
                            className={`flex flex-col items-center relative rounded-xl  w-full lg:w-[350px] bg-[#ededed] p-[2px]`}
                        >
                            <div className="font-semibold my-2">
                                {domain.title}
                            </div>
                            <div className="bg-white rounded-xl w-full flex flex-col items-center h-full px-4 md:px-8 py-6">
                                <div className="mb-8 mx-6 min-h-[60px]  flex justify-center items-center">
                                    <img
                                        src={domain.logo}
                                        alt={domain.domainName}
                                        className="max-w-[100%]"
                                    />
                                </div>
                                {domain.domainName && (
                                    <a
                                        className="text-black font-bold py-3 px-4 md:px-12 rounded-xl mt-auto transition hover:translate-y-[-5px] hover:shadow-md"
                                        href={`https://${
                                            domain.domainName
                                        }?referredBy=${
                                            currentDomain.name
                                        }${gettingQueriesAsString(
                                            query,
                                            "start",
                                            [
                                                "genericRoute",
                                                "keyword",
                                                "category",
                                                "formTemplate",
                                                "tool",
                                                "slug",
                                                "data",
                                                "zc",
                                                "filters",
                                                "pii-token",
                                            ],
                                        )}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{
                                            backgroundColor: domain.buttonColor,
                                            color: domain.buttonTextColor,
                                        }}
                                    >
                                        {domain.buttonText}
                                    </a>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CrossSellingDomains;
